import { TranslationObject } from '../../i18n/translation';

const namespace = 'fileupload';
const translations: TranslationObject = {
  wrongType: {
    id: `${namespace}.wrongType`,
    nb: 'Ugyldig filtype. Last opp en fil av type {types}',
    en: 'Invalid file type. Upload a file of type {types}',
  },
  tooLarge: {
    id: `${namespace}.tooLarge`,
    nb: 'Filen du forsøkte å laste opp var for stor. Maks. tillatte filstørrelse er {maxSize}MB',
    en: 'The file you attempted to upload was too large. Max. allowed file size is {maxSize}MB',
  },
  formattedName: {
    id: `${namespace}.formattedName`,
    nb: 'Du har lastet opp filen: {name}',
    en: 'You have uploaded the file: {name}',
  },
  removeBtn: {
    id: `${namespace}.removeBtn`,
    nb: 'Fjern filen',
    en: 'Remove file',
  },
};

export default translations;
